<template>
  <div style="position: relative">
    <label v-if="label" :class="['dr-text-area-spilka-ui-kit__label', { 'dr-text-area-spilka-ui-kit__label-empty-value': !value }]" for="dr-text-area-spilka-ui-kit">{{ label }}</label>
    <textarea 
			id="dr-text-area-spilka-ui-kit" 
			:value="value"
			:class="['dr-text-area-spilka-ui-kit__inner' ]" 
			@input="onInput"
			@change="onChange"
		/>
  </div>
</template>

<script>
import '../../tools/style/dr-text-area-spilka-ui-kit.scss'

export default {
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      Type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    labelVisible() {
      if (!this.value) {
        return false
      }

      return true
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value)
    },
    onChange(event) {
      this.$emit('change', event.target.value)
    }
  }
}
</script>